function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// xams-utils
import { check } from '@xams-utils/check-types';

// validation
import * as validate from './validation';

// constants
import { DEFAULT_VARIANT, BROWSERS, VARIANTS } from './constants';
var getFullValue = function getFullValue(list, value) {
  var initialValue = '';
  var _iterator = _createForOfIteratorHelper(list),
    _step;
  try {
    var _loop = function _loop() {
      var item = _step.value;
      if (check.array(item)) {
        var lowerCaseItems = item.map(function (subItem) {
          if (check.string(subItem)) {
            return subItem.toLowerCase();
          }
          return item;
        });
        if (lowerCaseItems.includes(value.toLowerCase())) {
          initialValue = item[0];
        }
      } else {
        if (item.toLowerCase() === value.toLowerCase()) {
          initialValue = item;
        }
      }
      if (initialValue !== '') {
        return 1; // break
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) break;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  ;
  return initialValue === '' ? value : initialValue;
};
var Browser = {
  create: function create(name) {
    var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_VARIANT;
    validate.nameType(name);
    validate.variantType(variant);
    return {
      name: getFullValue(BROWSERS, name),
      variant: getFullValue(VARIANTS, variant)
    };
  },
  toString: function toString(browser) {
    validate.browserType(browser);
    return browser.name;
  },
  equals: function equals(browser1, browser2) {
    validate.browserType(browser1);
    validate.browserType(browser2);
    return browser1.name.toLowerCase() === browser2.name.toLowerCase();
  },
  is: function is(browser) {
    if (!check.object(browser)) {
      return false;
    }
    if (check.undefined(browser.name)) {
      return false;
    }
    if (check.undefined(browser.variant)) {
      return false;
    }
    return true;
  }
};
Object.freeze(Browser);
export { Browser };